// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rank-list[data-v-910b8b92] {\n  background: #fff;\n  padding: 45px 20px 25px;\n}\n.rank-list .search-fail[data-v-910b8b92] {\n    color: #7e7e7e;\n    font-size: 14px;\n    line-height: 1.5em;\n}\n.rank-list .search-fail i[data-v-910b8b92] {\n      margin-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
